export { default as EldoComponent } from "./components/eldo-component";



// WEBPACK FOOTER //
// ./src/index.js